import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_API_KEY,
//   authDomain: process.env.REACT_APP_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_APP_ID,
//   measurementId: process.env.REACT_APP_MEASUREMENT_ID,
// };
const firebaseConfig = {
  apiKey: "AIzaSyDG0KCzN9zfgx-BvPpePkTDJOjBCYPWXVU",
  authDomain: "xencodes-3c61e.firebaseapp.com",
  projectId: "xencodes-3c61e",
  storageBucket: "xencodes-3c61e.appspot.com",
  messagingSenderId: "284069674791",
  appId: "1:284069674791:web:434692fb1fd71388e57302",
  measurementId: "G-DHEPHXQFF1"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

export const auth = firebaseApp.auth();
export const storage = firebaseApp.storage();
export const db = firebaseApp.firestore();
export default firebase.firestore();